import { render } from "./EditAttachment.vue?vue&type=template&id=8bb5d336&scoped=true"
import script from "./EditAttachment.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditAttachment.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditAttachment.vue?vue&type=style&index=0&id=8bb5d336&lang=scss&scoped=true"
import "./EditAttachment.vue?vue&type=style&index=1&id=8bb5d336&lang=scss&scope=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb5d336"]])

export default __exports__